// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3M0aF","box":"WorkspacesBox_box__3IUQQ","node":"WorkspacesBox_node__2bPiO"};